export const useScrollToPosition = pos => {
  window.scrollTo(0, pos)
}

export const useScrollToElement = el => {
  window.scrollTo(0, el.offsetTop)
}
